import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, toast, Slide } from 'react-toastify';
import update from 'immutability-helper';
import Interview from './Interview';
import './ProposalInterviews.scss';
var DEFAULT_INTERVIEW_LEN = 4;
var INTERVIEW_TYPE_ORDER = ['upcoming', 'pending', 'reschedule', 'past'];
var ProposalInterviews = /*#__PURE__*/function (_React$Component) {
  function ProposalInterviews(props) {
    var _this;
    _classCallCheck(this, ProposalInterviews);
    _this = _callSuper(this, ProposalInterviews, [props]);
    _this.state = {
      currentlyViewingMore: false,
      upcoming: _this.props.interviews.upcoming,
      pending: _this.props.interviews.pending,
      past: _this.props.interviews.past,
      reschedule: _this.props.interviews.reschedule
    };
    _this.handleViewMore = _this.handleViewMore.bind(_this);
    _this.removeInterview = _this.removeInterview.bind(_this);
    _this.handleInterviewMeetingDetailsSubmit = _this.handleInterviewMeetingDetailsSubmit.bind(_this);
    return _this;
  }
  _inherits(ProposalInterviews, _React$Component);
  return _createClass(ProposalInterviews, [{
    key: "getInterviews",
    value: function getInterviews(type) {
      var currentlyViewingMore = this.state.currentlyViewingMore;
      if (currentlyViewingMore) {
        return this.state[type];
      }
      var typeIndex = INTERVIEW_TYPE_ORDER.findIndex(function (t) {
        return type === t;
      });
      var priorInterviewsCount = 0;
      for (var ii = 0; ii < typeIndex; ii += 1) {
        priorInterviewsCount += this.state[INTERVIEW_TYPE_ORDER[ii]].length;
      }
      var spaceLeft = DEFAULT_INTERVIEW_LEN - priorInterviewsCount;

      // It is ok for slice to overshoot array bounds, but not undershoot (in this context).
      // Slice interprets negative numbers as an offset from the end.
      // But, if there is negative spaceLeft, then we don't want to return any interviews...
      // So, special case to return empty array if spaceLeft is negative.
      if (spaceLeft <= 0) {
        return [];
      }
      var interviewsOfType = this.state[type];
      return interviewsOfType.slice(0, spaceLeft);
    }
  }, {
    key: "removeInterview",
    value: function removeInterview(id, response) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'upcoming';
      var interviews = this.state[type];
      var newInterviews = interviews.filter(function (interview) {
        return interview.id !== id;
      });
      var toastMessage = response.data.message;
      var consultantView = this.props.consultantView;
      var rescheduleLink = "".concat(window.location.href, "?show_interview_modal=true");
      this.setState(_defineProperty({}, type, newInterviews));
      toast.success(/*#__PURE__*/React.createElement("span", null, toastMessage, !consultantView && /*#__PURE__*/React.createElement("span", null, "\xA0 Reschedule", ' ', /*#__PURE__*/React.createElement("a", {
        className: "reschedule-interview-link",
        href: rescheduleLink
      }, "here."))));
    }
  }, {
    key: "handleInterviewMeetingDetailsSubmit",
    value: function handleInterviewMeetingDetailsSubmit(response) {
      var id = response.data.id;
      var newMeetingDetails = response.data.meeting_details;
      var oldInterviews = this.state[response.data.type];
      var oldInterviewIndex = oldInterviews.findIndex(function (interview) {
        return interview.id === id;
      });
      var newInterviews = update(oldInterviews, _defineProperty({}, oldInterviewIndex, {
        meeting_details: {
          $set: newMeetingDetails
        }
      }));
      var setStateArg = _defineProperty({}, response.data.type, newInterviews);
      this.setState(setStateArg);
    }
  }, {
    key: "handleViewMore",
    value: function handleViewMore(currentlyViewingMore) {
      this.setState({
        currentlyViewingMore: currentlyViewingMore
      });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var copy;
      if (this.props.consultantView) {
        copy = 'My interviews for this project';
      } else {
        copy = "".concat(this.props.consultantName, "'s interviews");
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "interviews-header medium-weight body-text-1  mb-3 "
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-calendar-alt me-2"
      }), copy);
    }
  }, {
    key: "renderInterviews",
    value: function renderInterviews(type) {
      var _this2 = this;
      var _this$props = this.props,
        possibleInterviewers = _this$props.possibleInterviewers,
        invitableRoles = _this$props.invitableRoles,
        csrfToken = _this$props.csrfToken,
        canCancel = _this$props.canCancel,
        canEdit = _this$props.canEdit,
        consultantView = _this$props.consultantView,
        consultantInterviewPath = _this$props.consultantInterviewPath,
        proposalId = _this$props.proposalId,
        isRep = _this$props.isRep,
        repOrOwner = _this$props.repOrOwner,
        availableInterviewSlotUrl = _this$props.availableInterviewSlotUrl;
      var interviews = this.getInterviews(type);
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(type, "-interviews-list-container  mb-3 ")
      }, interviews.map(function (interview) {
        return /*#__PURE__*/React.createElement(Interview, {
          key: interview.id,
          interviewType: type,
          interview: interview,
          possibleInterviewers: possibleInterviewers,
          invitableRoles: invitableRoles,
          onCancel: _this2.removeInterview,
          onSubmitMeetingDetails: _this2.handleInterviewMeetingDetailsSubmit,
          isRep: isRep,
          canCancel: canCancel,
          canEdit: canEdit,
          consultantView: consultantView,
          csrfToken: csrfToken,
          consultantInterviewPath: consultantInterviewPath,
          proposalId: proposalId,
          repOrOwner: repOrOwner,
          availableInterviewSlotUrl: availableInterviewSlotUrl
        });
      })), interviews.length > 0 && /*#__PURE__*/React.createElement("hr", {
        className: "interview-list-divider"
      }));
    }
  }, {
    key: "renderViewMore",
    value: function renderViewMore() {
      var _this3 = this;
      var currentlyViewingMore = this.state.currentlyViewingMore;
      var ctaCopy = currentlyViewingMore ? 'View Less' : 'View All';
      var totalInterviewCount = this.state.upcoming.length + this.state.past.length + this.state.pending.length;
      if (totalInterviewCount <= DEFAULT_INTERVIEW_LEN) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "interview-view-all-link-container"
      }, /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: "0",
        className: "interview-view-all-link body-text-2 medium-weight",
        onClick: function onClick() {
          return _this3.handleViewMore(!currentlyViewingMore);
        }
      }, ctaCopy));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      return /*#__PURE__*/React.createElement("div", {
        className: "interviews-container"
      }, /*#__PURE__*/React.createElement(ToastContainer, {
        position: "bottom-center",
        transition: Slide,
        hideProgressBar: true,
        autoClose: 8000,
        closeOnClick: true,
        draggable: false,
        pauseOnHover: true,
        pauseOnFocusLoss: true,
        className: "cancelled-interview-toast-container",
        toastClassName: "cancelled-interview-toast",
        bodyClassName: "cancelled-interview-toast-body"
      }), this.renderHeader(), /*#__PURE__*/React.createElement("div", {
        className: "interviews"
      }, INTERVIEW_TYPE_ORDER.map(function (type) {
        return /*#__PURE__*/React.createElement("div", {
          key: type,
          id: type
        }, _this4.renderInterviews(type));
      })), this.renderViewMore());
    }
  }]);
}(React.Component);
ProposalInterviews.propTypes = {
  interviews: PropTypes.shape({
    upcoming: PropTypes.arrayOf(PropTypes.shape({})),
    past: PropTypes.arrayOf(PropTypes.shape({})),
    pending: PropTypes.arrayOf(PropTypes.shape({})),
    reschedule: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  consultantName: PropTypes.string.isRequired,
  possibleInterviewers: PropTypes.shape({}),
  invitableRoles: PropTypes.arrayOf(PropTypes.string),
  isRep: PropTypes.bool,
  canCancel: PropTypes.bool,
  canEdit: PropTypes.bool,
  consultantView: PropTypes.bool,
  repOrOwner: PropTypes.bool,
  csrfToken: PropTypes.string.isRequired,
  consultantInterviewPath: PropTypes.string,
  proposalId: PropTypes.number.isRequired,
  availableInterviewSlotUrl: PropTypes.string.isRequired
};
ProposalInterviews.defaultProps = {
  possibleInterviewers: [],
  invitableRoles: [],
  isRep: false,
  canCancel: false,
  canEdit: false,
  consultantView: false,
  repOrOwner: false,
  consultantInterviewPath: ''
};
export default ProposalInterviews;